<template>
  <div class="authID-container">
    <!-- 상단 타이틀 영역 -->
    <div class="title-wrap">
      <div class="title">
        {{ $t("Verification.common.verification.title") }}
      </div>
      <div class="close-button" @click="closeAuthID">
        <img
          src="../../../../../../src/assets/img/mypage/close-button.svg"
          alt=""
        />
      </div>
    </div>
    <!-- //상단 타이틀 영역 -->

    <!-- 컨텐츠 -->
    <div class="content-wrap">
      <!-- 내 정보 > 인증센터 > 신원인증 -->
      <div v-if="noti" class="noti">
        <p
          v-html="
            $t('Verification.common.verification.doVerificationDescription')
          "
        ></p>
        <button @click="toStep1" class="next-button bottom">
          {{ $t("Verification.common.next") }}
        </button>
      </div>
      <!-- //내 정보 > 인증센터 > 신원인증 -->

      <!-- 신원인증 시작. step1 -->
      <div v-else-if="step1" class="step">
        <step1
          @tostep2="toStep2"
          :data.sync="step1data"
          :locale.sync="locale"
        ></step1>
      </div>
      <!-- //신원인증 시작. step1 -->

      <!-- 휴대폰인증/orc. step2 -->
      <div v-else-if="step2" class="step">
        <step2
          @tostep1="toStep1"
          @tostep3="toStep3"
          @toconfirm2="toConfirm2"
          :data.sync="step2data"
          :step2.sync="step2"
        ></step2>
      </div>
      <!-- //휴대폰인증/orc. step2 -->

      <!-- 인증 확인 -->
      <div v-else-if="step2data.confirm" class="step">
        <confirm-step2
          @tostep2="toStep2"
          @tostep3="toStep3"
          :step2data.sync="step2data"
          :data.sync="step2data"
        ></confirm-step2>
      </div>
      <!-- // 인증 확인 -->

      <!-- 국내 비거주 외국인. 휴대폰 점유 인증. step2 -->
      <div v-else-if="step2cpn" class="step">
        <step-2-check-phone-number
          :data.sync="step2cpndata"
          :cntlocalcode.sync="selectedNationNumber"
          :locale.sync="locale"
          @tostep1="toStep1"
          @tostep3="toStep3fromStep2cpn"
        ></step-2-check-phone-number>
      </div>
      <!-- // 국내 비거주 외국인. 휴대폰 점유 인증. step2 -->

      <!-- 기본정보. step3 -->
      <div v-else-if="step3" class="step">
        <step3
          @tostep2="toStep2"
          @tostep4="toStep4"
          :step1data.sync="step1data"
          :step2data.sync="step2data"
          :data.sync="step3data"
          :step2cpndata.sync="step2cpndata"
          :cntlocalcode.sync="selectedNationNumber"
        ></step3>
      </div>
      <!-- //기본정보. step3 -->

      <!-- 본인계좌 인증. step4 -->
      <div v-else-if="step4" class="step">
        <step4
          @tostep3="backToStep3"
          @closeall="closeAll"
          @submit="submit"
          :step2data.sync="step2data"
          :data.sync="step4data"
        ></step4>
      </div>
      <!-- //본인계좌 인증. step4 -->

      <!-- 국내 거주 외국인. step4 -->
      <div v-else-if="step4kr" class="step">
        <step4-in-kr
          :data.sync="step4krdata"
          @submit="submitforeigner"
        ></step4-in-kr>
      </div>
      <!-- //국내 거주 외국인. step4 -->

      <!-- 국내 비거주 외국인. step4 -->
      <div v-else-if="step4others" class="step">
        <step4-in-others
          :data.sync="step4othersdata"
          @submit="submitforeigner"
        ></step4-in-others>
      </div>
      <!-- //국내 비거주 외국인. step4 -->
    </div>
    <!-- //컨텐츠 -->

    <!-- 신원인증 종료 팝업 -->
    <vs-popup
      :title="$t('Verification.common.closeAuth.title')"
      :button-close-hidden="true"
      :active.sync="closeAuthIDModal"
      class="small-popup"
    >
      <div class="text-wrap">
        <div class="text-detail">
          <p
            class="center"
            v-html="$t('Verification.common.closeAuth.noti')"
          ></p>
        </div>
      </div>
      <div class="button-wrap">
        <button @click="toconfirm">
          {{ $t("Verification.common.closeAuth.close") }}
        </button>
        <button @click="closeAuthIDModal = false">
          {{ $t("Verification.common.closeAuth.no") }}
        </button>
      </div>
    </vs-popup>
    <!-- //신원인증 종료 팝업 -->
    <!-- 외국인 신원인증 심사 중 팝업 -->
    <vs-popup
      :title="$t('Verification.popup.process.title')"
      :button-close-hidden="true"
      :active.sync="foreignerAuthIDModal"
      class="medium-popup"
    >
      <div class="text-wrap">
        <div class="text-detail">
          <div class="text-box mt0">
            <p class="title">
              {{ $t("Verification.step5.VideoCallConfirm.title") }}
            </p>
            <div class="contents gray-box mt8">
              <div class="list">
                <p class="item">
                  {{ $t("Verification.step5.VideoCallConfirm.description[0]") }}
                </p>
                <p class="item mt4">
                  {{ $t("Verification.step5.VideoCallConfirm.description[1]") }}
                </p>
              </div>
            </div>
            <p class="title mt12">
              {{ $t("Verification.step5.videoCall.title") }}
            </p>
            <div class="contents gray-box mt8">
              <div class="list">
                <p
                  class="item"
                  v-html="$t('Verification.step5.videoCall.information[0]')"
                ></p>
                <p
                  class="item mt4"
                  v-html="$t('Verification.step5.videoCall.information[1]')"
                ></p>
                <p
                  class="item mt4"
                  v-html="$t('Verification.step5.videoCall.information[2]')"
                ></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="button-wrap">
        <button @click="toconfirm">
          {{ $t("confirm.ok") }}
        </button>
      </div>
    </vs-popup>
    <!-- //외국인 신원인증 심사 중 팝업 -->
    <!-- 신원인증 신청 완료 팝업 -->
    <vs-popup
      :title="$t('Verification.popup.finished.title')"
      :button-close-hidden="true"
      :active.sync="step4data.finishedModal"
      class="medium-popup"
    >
      <div class="text-wrap">
        <div class="text-detail">
          <div class="text-box mt0">
            <!-- <p class="title">
            {{$t('Verification.popup.process.subTitle')}}
          </p> -->
            <div class="contents gray-box">
              <div class="list">
                <div
                  v-html="$t('Verification.popup.finished.description')"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="button-wrap">
        <button @click="closeAll">{{ $t("confirm.ok") }}</button>
      </div>
    </vs-popup>
    <!-- // 신원인증 신청 완료 팝업 -->
  </div>
</template>
<script>
import step1 from "./CDD-steps/step1.vue";
import step2 from "./CDD-steps/step2.vue";
import confirmStep2 from "./CDD-steps/step2_confirm.vue";
import step2CheckPhoneNumber from "./CDD-steps/step2_checkPhoneNumber.vue";
import step3 from "./CDD-steps/step3.vue";
import step4 from "./CDD-steps/step4.vue";
import step4InKr from "./CDD-steps/step4_foreigner_inKR.vue";
import step4InOthers from "./CDD-steps/step4_foreigner_inOthers.vue";
// import CookieControl from "@/common/CookieControl";
import Api from "@/common/Api";
import { mapGetters } from "vuex";
import Moment from "moment";
import { firebaseCustomEvent } from "@/util/firebase_config";
import axios from "axios";

export default {
  components: {
    step1,
    step2,
    confirmStep2,
    step3,
    step4,
    step2CheckPhoneNumber,
    step4InKr,
    step4InOthers,
  },
  created() {
    this.step1data.beforeNation = this.userInfo.dueDiligenceInfo
      ? this.userInfo.dueDiligenceInfo.foreignYn
      : "";
  },
  async mounted() {
    const query = this.$route.query;
    /* query = {
      residence : 1
      state: '~~'
      code: '~~'
    }
    */
    if (query.reAuth == "Y") {
      this.reTry = "Y";
    } else {
      this.reTry = "N";
    }
  },

  data() {
    return {
      noti: true, // 안내
      step1: false, // 신원인증 시작
      step2: false, // step2. nice/ocr
      step2cpn: false, // 국내 비거주 외국인 step2
      step3: false, // 직업 step3
      step4: false, // 본인계좌 인증
      step4kr: false, // 본인계좌 인증
      step4others: false, // 본인계좌 인증
      closeAuthIDModal: false, // 신원인증 종료 안내 팝업
      foreignerAuthIDModal: false, // 외국인 신원인증 심사 중 팝업
      reTry: "", //재인증
      lastSubmit: {}, //최종 전달 정보
      lastRes: "", //외국인 최종 response data. jSON으로 api 호출 시 필요한 값.
      // step1 data
      step1data: {
        private: false, // 개인정보 수집 및 이용 동의
        // nation: this.$t('Verification.step1.selectYourNationality'), // 국적 확인
        nationality: "Republic Of Korea/대한민국", // 국적 확인(내국인만 받을 때 디폴트로)
        selectedKorean: true, // 내국인 선택
        selectedForeigner: false, // 외국인 선택
        abled: true, //disabled 아닌 상태
        domesticYn: "Y", //국내 거주
        liveInAnothers: false, //국내 비거주
        agreeChecked: false, //개인정보 수집 이용 동의 체크박스
        unique: false, //고유식별정보 수집 이용 동의 체크박스
        openPrivateTerms: false, // 개인정보 수집 및 이용 동의 자세히 보기
        nationsModal: false, // 국가 선택 팝업
        nationItems: [], // 국가 선택 data
        // 외국인
        foreigner: {
          // 국내 거주 외국인
          birthDate: "", // 생년월일
          mobileNo: "", // 휴대폰번호
          name: "", // 이름
          gender: "", // 성별
          ci: "", //나이스 ci
        },
        beforeNation: "", //이전 인증 시 국적
        selectedCountryCode: "", // (외국인) 선택 국적 2자 영문 코드
      },
      // step2 data
      step2data: {
        // confirm: false, // 진위여부 페이지
        // // ocr version
        // maskingImage: "",
        // cropImage: "",
        // formCode: "",
        // formName: "",
        // fullIdNum: "", // 주민등록번호 전체
        // birth: "19870807", //생년월일
        // inIdNum: "2692411", // 주민등록번호 뒷자리
        // driverLicenseNo: "", //운전면허 번호
        // serialNo: "", //식별 번호,
        // name: "이나리",
        // getOcrName: "",
        // issueDate: "20090702",
        // // gender: "F",
        // file1: "",
        // file2: "",
        // inIdCerDate: "", //신분증 인증 일시
        // phoneCerDate: "", // 휴대폰 인증 일시
        // ocrResult: "0", // ocr 결과 코드
        // // nice res
        // getBirthDate: "19870807", // 생년월일 8자리
        // ci: "", // null
        // di: "", // string
        // gender: "F", // F/M
        // mobileNo: "01038008756",
        // // name: "",
        // nationalInfo: "Y", // Y/N
        // niceResult: true, // nice 성공/실패
        confirm: false, // 진위여부 페이지
        // ocr version
        maskingImage: "",
        cropImage: "",
        formCode: "",
        formName: "",
        fullIdNum: "", // 주민등록번호 전체
        birth: "", //생년월일
        inIdNum: "", // 주민등록번호 뒷자리
        driverLicenseNo: "", //운전면허 번호
        serialNo: "", //식별 번호,
        name: "",
        getOcrName: "",
        issueDate: "",
        gender: "",
        file1: "",
        file2: "",
        inIdCerDate: "", //신분증 인증 일시
        phoneCerDate: "", // 휴대폰 인증 일시
        ocrResult: "0", // ocr 결과 코드
        // nice res
        getBirthDate: "", // 생년월일 8자리
        ci: "", // null
        di: "", // string
        gender: "", // F/M
        mobileNo: "",
        name: "",
        nationalInfo: "", // Y/N
        niceResult: false, // nice 성공/실패

        // 아래 data는 nice res 테스트용!
        // getBirthDate: "19870807", // 생년월일 8자리
        // ci: "MC0GCCqGSIb3DQIJAyEAojhp9XfHewYeeuamcQva1gRfS4bsFjZon1w3CcAfiS8=", // null
        // di: "MC0GCCqGSIb3DQIJAyEAojhp9XfHewYeeuamcQva1gRfS4bsFjZon1w3CcAfiS8=", // string
        // getGender: "F", // F/M
        // mobileNo: "01038008756",
        // getName: "이나리",
        // nationalInfo: "Y", // Y/N
        // niceResult: true, // nice 성공/실패
      },
      // step3 data
      step3data: {
        activeBtn: false, // 주민번호 유효성 검사에 따른 다음 버튼 활성화
        wrongNumber: false, // 주민번호 유효성 검사에 따른 안내문구 노출 여부
        oneThird: true, // 고객정보 확인 3-1
        twoThird: false, // 고객정보 확인 3-2
        threeThird: false, // 추가정보. 직장인 or 전문직
        fourThird: false, // 추가정보. 개인사업자/자영업자
        Address: false, // 주소검색
        // officeAddress: false, // 직장주소검색
        purposeModal: false, //거래목적 선택 팝업
        sourceOfFundModal: false, //자금출처 선택 팝업
        realOwnerModal: false, //실제 소유자여부 선택 팝업
        jobModal: false, //직업 선택 팝업
        purposeList: "0", // 거래목적 선택 list v-model
        purposeCode: "", //거래목적 코드
        sourceOfFundModalList: "0", // 자금출처 선택 list v-model
        realOwnerModalList: "0", // 실제 소유자여부 선택 list v-model
        jobModalList: "0", // 직업 선택 list v-model
        changeBoxP: false, // 거래목적 리스트 라디오 버튼 클릭 시 스타일 변경
        changeBoxS: false, // 자금출처 리스트 라디오 버튼 클릭 시 스타일 변경
        changeBoxR: false, // 실제 소유자여부 리스트 라디오 버튼 클릭 시 스타일 변경
        changeBoxJ: false, // 직업 리스트 라디오 버튼 클릭 시 스타일 변경
        notiModal: false, // 실제 소유자 아님 시 안내 팝업
        clickOfficeWorker: false, // 직장 > 직장인 리스트 선택
        clickProfessional: false, // 직장 > 전문직 리스트 선택
        clickPrivateBusiness: false, // 직장 > 개인사업자/자영업자 리스트 선택
        agreeChecked: false, // 동의합니다 체크박스
        enSurname: "", // 3-1 영문 성
        enGivenName: "", // 3-1 영문 이름
        personalCode: "", //주민등록번호 뒤 7자리
        address: "", // 3-1 주소
        officeName: "", // 3-3 직장이름(직장인/전문직->고위험군)
        officePart: "", // 3-3 직장부서명(직장인/전문직->고위험군)
        officeLevel: "", // 3-3 직장직위(직장인/전문직->고위험군)
        officeNumber: "", // 3-3 직장연락처(직장인/전문직->고위험군)
        // officeAddress: "", // 3-3 직장주소
        searchAddress: "", //주소 입력값
        addressResult1: "", // 도로명주소
        addressResult2: "", //지번주소
        zoneNo: "", //우편번호
        result: false, // 주소 검색 결과
        purposeItems: [], // 거래목적 선택 data
        sourceOfFundItems: [], // 자금출처 선택 data
        sourceOfFundCode: "", //자금출처 선택 code
        realOwnerItem: [], // 실제 소유자여부 선택 data
        jobItem: [], // 직업 선택 data
        jobCode: "", //직업 선택 code
        clickedJobType: "", // 선택된 job type
        clickedJobDanger: "", // 선택된 job danger
        indutyName: "", //업체명(개인사업자/자영업자->고위험군)
        induty: "", //업종명(개인사업자/자영업자->고위험군)
        bizIdNumber: "", //사업자등록번호(개인사업자/자영업자->고위험군)
        foundDate: "", //설립일자(개인사업자/자영업자->고위험군)
        bizNumber: "", //사업장연락처(개인사업자/자영업자->고위험군)
        // 주소
        searchData: {
          addr1: "",
          addr2: "",
          addr3: "",
        },
        // 직장인/전문직 직장 주소
        searchOfficeData: {
          addr1: "",
          addr2: "",
          addr3: "",
        },
        // 개인사업자/자영업 업체 주소
        searchPersonalData: {
          addr1: "",
          addr2: "",
          addr3: "",
        },
        idCardStartDate: "", //국내 거주 외국인 외국인등록증발급일자
        idCardEndDate: "", //국내 거주 외국인 외국인등록증만료일자
        genderModal: false, //국내 비거주 외국인 성별 선택 팝업
        genderList: "0", //국내 비거주 외국인 성별 선택 list v-model
        genderItems: [{ gender: "M" }, { gender: "F" }], //성별 선택 data
        passportNumber: "", //여권 번호
        foreignerbirth: "", //국내 비거주 외국인 생년월일
        jobCategory: "", // job category(api 호출용)
        riskCountryResult: "", // 위험국가 여부
        showAddress: false,
      },
      // step4 data
      step4data: {
        oneForth: true, // 4-1
        twoForth: false, // 4-2
        bankList: null,
        bankMCode: "", // 은행명
        bankAccount: "", //계좌번호
        success: false, //계좌 조회 성공
        bankName: "", // 계좌명
        checkAccount: false, // 계좌 확인 버튼 활성화
        changeBank: false, //다른 은행 선택 버튼 활성화
        wrongOwner: false, // 본인 명의의 계좌가 아닙니다 팝업
        wrongAccount: false, // 잘못된 계좌번호입니다 팝업
        limitAccountModal: false, // 3회 초과 알림 팝업
        wrongAuthNumber: false, // 1원 검증 번호 오류 팝업
        sendMoney: false, // 1원을 정상 이체 팝업
        // wrongNumber: false, // 1원 인증번호 오류 팝업
        processModal: false, // 신원인증 심사 안내 팝업
        authNumberFirst: "", //인증번호 1 입력
        // authNumberSecond: "", //인증번호 2 입력
        // authNumberThird: "", //인증번호 3 입력
        checkAccount: false, // 계좌확인 버튼 활성화
        findBank: {}, // 선택 은행 정보
        uuidx: "", // userinfo의 uuidx
        checkCount: "", // 1원 검증 횟수
        accountCerDate: "", // 1원 검증 인증 날짜
        wrongAccountMessage: "", // 1원 검증 오류 메시지
        finishedModal: false, // 신청 완료 모달
        sendMoneyTime: "",
        send: false,
      },
      // 국내 비거주 외국인 step2 data
      step2cpndata: {
        enSurname: "", // 영문 성
        enGivenName: "", // 영문 이름
        nationality: this.$t("Verification.step1.selectYourNationality"), // 통신사 국가 확인
        nationsModal: false, // 국가 선택 팝업
        nationItems: [], // 국가 선택 data arra
        cntlocalcode: "", // 선택한 통신사 국가 번호
        personalCode: "", // 휴대폰 번호
        authNumber: "", // 인증번호
        selectedNationObject: {}, //선택한 통신사 국가
        mobNumber: "", // api return 휴대폰번호
      },
      // 국내 거주 외국인 data
      step4krdata: {
        uploadImageFile1: null,
        uploadImageFile2: null,
        ali_response: {},
        rcapt_id: null,
        files: {
          idCardFront: {},
          idCardEnd: {},
        },
      },
      // 국내 비거주 외국인 data
      step4othersdata: {
        uploadImageFile1: null,
        uploadImageFile2: null,
        uploadImageFile3: null,
        ali_response: {},
        rcapt_id: null,
        files: {
          passport: "",
          identityDocument: "",
          dues: "",
        },
      },
      last: {
        params: {},
        params2: {},
        info: {},
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    //선택 통신사 국가 번호
    selectedNationNumber() {
      if (
        this.step2cpndata.nationality !==
        this.$t("Verification.step1.selectYourNationality")
      ) {
        this.step2cpndata.selectedNationObject = _.find(
          this.step2cpndata.nationItems,
          (ele) => ele.cntName == this.step2cpndata.nationality.split("/")[0]
        );
        return "+" + this.step2cpndata.selectedNationObject.cntLocalCode; //국가 번호
      }
    },
    //선택 국적 알파벳 코드
    selectedKycCode() {
      this.step1data.selectedNationObject = _.find(
        this.step1data.nationItems,
        (ele) => ele.cntName == this.step1data.nationality.split("/")[0]
      );
      return this.step1data.selectedNationObject.cntCode; //국가 코드
    },
    locale() {
      return this.$t("Verification.step1.selectYourNationality");
    },
  },
  methods: {
    // 인증센터로 돌아가기
    closeAuthID() {
      this.closeAuthIDModal = true;
    },
    // 신원인증 시작으로 이동
    toStep1() {
      this.noti = false;
      this.step1 = true;
      this.step2 = false;
      this.step2cpn = false;
    },
    // 2단계로 이동
    toStep2() {
      if (this.step1data.selectedForeigner) {
        // 외국인
        if (this.step1data.domesticYn == "Y") {
          //국내 거주
          window.open(
            `${Api.Comm.url}auth/cdd-edd/foreigner/nice/view/W`,
            "chkPopup",
            "width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no"
          );
        } else {
          //비거주
          this.step1 = false;
          this.step2cpn = true;
        }
      } else {
        //내국인
        this.step1 = false;
        this.step2 = true;
        // window.location.search = '';
        this.step3 = false;
      }
    },
    //
    toConfirm2() {
      this.noti = false;
      this.step1 = false;
      this.step2 = false;
      this.step2data.confirm = true;
      this.step2cpn = false;
    },
    async recieveResult(result, niceVO) {
      // result는 true/false로만
      // niceVO는 PASS 결과값
      this.step1data.foreigner = niceVO;

      try {
        const res = await Api.getAuthResultForeigner();
        const FailMessage = res.data.result.msg.slice(7);
        const resultStatus = res.data.result.successful;
        switch (resultStatus) {
          case "S":
            // 인증 성공
            this.step1 = false;
            this.step3 = true;
            break;
          case "M":
          case "I":
            // 미성년자, 외국인
            // this.$alert(this.authFailMsg);
            this.$alert(FailMessage);
            break;
          default:
            // 인증 실패
            this.$alert(this.authFailMsg);
            break;
        }
      } catch (error) {
        console.log(error);
        this.authFailMsg = "본인인증에 실패했습니다.";
        this.$alert(this.authFailMsg);
      }
    },

    // step3 고객정보확인으로 이동
    async toStep3() {
      this.step2data.confirm = false;
      this.step3 = true;
      this.step4 = false;
    },
    // step3 고객정보확인으로 이동
    backToStep3() {
      this.step3data.twoThird = false;
      this.step3data.threeThird = false;
      this.step3data.fourThird = false;
      this.step3 = true;
      this.step4 = false;
      const jobCategory = this.step3data.jobCategory; // job category
      if (jobCategory == "0") {
        this.step3data.twoThird = true;
      } else if (jobCategory == "1") {
        this.step3data.threeThird = true;
      } else {
        this.step3data.fourThird = true;
      }
    },
    //국내 비거주 외국인 stpe3
    toStep3fromStep2cpn() {
      this.step2cpn = false;
      this.step3 = true;
    },
    // 본인계좌인증으로 이동
    toStep4() {
      // 내국인
      if (this.step1data.selectedKorean) {
        this.step3 = false;
        this.step4 = true;
      } else {
        // 외국인 국내 거주
        if (this.step1data.domesticYn == "Y") {
          this.step3 = false;
          this.step4kr = true;
        } else {
          // 외국인 국내 비거주
          this.step3 = false;
          this.step4others = true;
        }
      }
    },
    // 신원인증 종료 버튼
    toconfirm() {
      this.closeAuthIDModal = false;
      this.foreignerAuthIDModal = false;
      this.step4kr = false;
      this.step4others = false;
      this.$router.push({ name: "confirm" });
    },
    closeAll() {
      this.step4data.finishedModal = true;
      this.step4 = false;
      this.step4kr = false;
      this.step4others = false;
      this.$router.push({ name: "confirm" });
    },
    // 내국인 고객 정보 최종 api 호출
    async submit() {
      // firebase event check
      firebaseCustomEvent("checkAuth", {
        midx: "midx : " + String(this.userInfo.id),
        authNumber: "인증번호 : " + String(this.step4data.authNumberFirst),
      });

      // try {
      try {
        this.last.params = {
          mchtCustId: String(this.userInfo.uuidx),
          authNo: String(this.step4data.authNumberFirst),
          trdNo: String(this.step4data.checkNumberapiData.data.result.trdNo),
          mchtTrdNo: String(
            this.step4data.checkNumberapiData.data.result.mchtTrdNo
          ),
          custAcntNo: String(this.step4data.bankAccount),
          bankCd: String(this.step4data.findBank.code),
          orgTrdDt: String(
            this.step4data.checkNumberapiData.data.result.orgTrdDt
          ),
        };
        const res = await Api.User.verifyAcntOccpCheck(this.last.params); // 세틀뱅크 1원 검증
        this.step4data.accountCerDate = res.data.result.accountCerDate;
      } catch (error) {
        if (error.msg) {
          if (this.$isDevServer) {
            this.$vs.notify({
              title: this.$t("notice.title.error"),
              text: "verify<br>" + `${error.code}` + `${error.msg}`,
              position: "top-right",
              color: "danger",
            });
            return;
          } else {
            this.$vs.notify({
              title: this.$t("notice.title.error"),
              text: "verify<br>" + `${error.msg}`,
              position: "top-right",
              color: "danger",
            });
            return;
          }
        } else {
          if (this.$isDevServer) {
            this.$vs.notify({
              title: this.$t("notice.title.error"),
              text: `verify<br>${error.code}<br>입력하신 정보를 다시 확인해 주세요.`,
              position: "top-right",
              color: "danger",
            });
            return;
          } else {
            this.$vs.notify({
              title: this.$t("notice.title.error"),
              text: `verify<br>입력하신 정보를 다시 확인해 주세요.`,
              position: "top-right",
              color: "danger",
            });
            return;
          }
        }
      }

      // base64 to file - cropImg
      const cropB64 = this.step2data.cropImage;
      var raw = window.atob(cropB64); // decoding
      var rawLength = raw.length; // 길이
      var uInt8Array = new Uint8Array(rawLength);
      for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      const cropImgFile = new Blob([uInt8Array], { type: "png" });

      // base64 to file - maskingImg
      const maskingB64 = this.step2data.maskingImage;
      var raw = window.atob(maskingB64); // decoding
      var rawLength = raw.length; // 길이
      var uInt8Array = new Uint8Array(rawLength);
      for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      const maskingImgFile = new Blob([uInt8Array], { type: "png" });

      try {
        this.last.info = {
          midx: this.userInfo.id, //회원idx
          birth: this.step2data.getBirthDate, //생년월일 8자리
          domesticYn: this.step1data.domesticYn == "Y" ? "Y" : "N", // 국내거주여부
          nation: this.step1data.nationality, //국적
          memberSex: this.step2data.gender, //멤버성별
          residenceNation:
            this.step1data.domesticYn == "Y" ? this.step1data.nationality : "-", //거주국가
          name: this.step2data.name, //이름
          engName1: this.step3data.enSurname, //영문이름(surname)
          engName2: this.step3data.enGivenName, //영문이름(given name)
          inIdNum: this.step2data.birth + this.step2data.inIdNum, // 주민등록번호
          mobNumber: this.step2data.mobileNo, //휴대폰번호
          addr1: this.step3data.searchData.addr1, //주소1
          addr2: this.step3data.searchData.addr2, //주소2
          addr3: this.step3data.searchData.addr3, //주소3
          tradePur: this.step3data.purposeCode, //거래목적
          capiOrigin: this.step3data.sourceOfFundCode, //자금출처
          realOwnerYn:
            this.step3data.realOwnerModalList == "실제 소유자 맞음" ? "Y" : "N", //실소유자여부
          cerCi: this.step2data.ci, // CI값
          cerDi: this.step2data.di, // DI값
          job: this.step3data.jobCode, // 직업명
          jobCategory: this.step3data.jobCategory, //type, danger
          jobName: this.step3data.officeName, // 직장명
          jobNumber: this.step3data.officeNumber, //직장 연락처
          jobAddr1: this.step3data.searchOfficeData.addr1, //직장주소1(우편번호)
          jobAddr2: this.step3data.searchOfficeData.addr2, //직장주소2(검색주소)
          jobAddr3: this.step3data.searchOfficeData.addr3, //직장주소3(상세주소)
          deptName: this.step3data.officePart, //부서명
          position: this.step3data.officeLevel, //직위
          bizIdNumber: this.step3data.bizIdNumber, //사업자등록번호
          bizNm: this.step3data.indutyName, //업체명
          induty:
            this.step3data.jobCategory == "2"
              ? this.step3data.jobModalList
              : "", //업종명 = 직업과 동일
          foundDate: this.step3data.foundDate
            ? Moment(this.step3data.foundDate).format("YYYY-MM-DD")
            : null, //설립일자
          bizNumber: this.step3data.bizNumber, //사업장연락처
          bizAddr1: this.step3data.searchPersonalData.addr1, //사업장주소(우편번호)
          bizAddr2: this.step3data.searchPersonalData.addr2, //사업장주소(검색주소)
          bizAddr3: this.step3data.searchPersonalData.addr3, //사업장주소(상세주소)
          contractYn: this.step3data.agreeChecked == true ? "Y" : "N", //서약서제출여부
          bank: this.step4data.bankMCode, //은행명
          bankAccount: this.step4data.bankAccount, //계좌번호
          bankName: this.step4data.bankName, //계좌명(예금주)
          regDate: this.step4data.checkNumberapiData.data.result.orgTrdDt, //등록일자
          nationCode: "KR", //국가코드. 추후 외국인 추가작업 필요
          cddYn: this.step1data.agreeChecked == true ? "Y" : "N", //수집동의여부
          idSe: this.step2data.formCode == "S01000001" ? "I" : "L", //ID 주민등록증 or 운전면허증
          driverLicenseNo: this.step2data.driverLicenseNo, //운전면허증 번호
          serialNo: this.step2data.serialNo, //운전면허(식별번호)
          joinChannelSe: "MW", //가입채널구분
          inIdCerDate: this.step2data.inIdCerDate, //신분증 인증 일시
          // phoneCerDate: "2022-04-03 11:22:33", //휴대폰 인증 일시
          phoneCerDate: this.step2data.phoneCerDate, //휴대폰 인증 일시
          accountCerDate: this.step4data.accountCerDate, // 1원 검증 인증 날짜
          sbStatus: this.reTry == "Y" ? "RE" : "R", //재인증 여부 체크
        };
      } catch (error) {
        if (error.msg) {
          if (this.$isDevServer) {
            this.$vs.notify({
              title: this.$t("notice.title.error"),
              text: "authInfo<br>" + `${error.code}` + `${error.msg}`,
              position: "top-right",
              color: "danger",
            });
            return;
          } else {
            this.$vs.notify({
              title: this.$t("notice.title.error"),
              text: "authInfo<br>" + `${error.msg}`,
              position: "top-right",
              color: "danger",
            });
            return;
          }
        } else {
          if (this.$isDevServer) {
            this.$vs.notify({
              title: this.$t("notice.title.error"),
              text: `authInfo<br>${error.code}<br>입력하신 정보를 다시 확인해 주세요.`,
              position: "top-right",
              color: "danger",
            });
            return;
          } else {
            this.$vs.notify({
              title: this.$t("notice.title.error"),
              text: `authInfo<br>입력하신 정보를 다시 확인해 주세요.`,
              position: "top-right",
              color: "danger",
            });
            return;
          }
        }

        // if (error.msg) {
        //   if (this.$isDevServer) {
        //     return (this.step4data.wrongAccountMessage = `authInfo<br>${error.code}<br>${error.msg}`);
        //   } else {
        //     return (this.step4data.wrongAccountMessage = `authInfo<br>${error.msg}`);
        //   }
        // } else {
        //   if (this.$isDevServer) {
        //     return (this.step4data.wrongAccountMessage = `authInfo<br>${error.code}<br>입력하신 정보를 다시 확인해 주세요.`);
        //   } else {
        //     return (this.step4data.wrongAccountMessage = `authInfo<br>입력하신 정보를 다시 확인해 주세요.`);
        //   }
        // }
      }
      // last data

      // 최종 api 호출
      try {
        this.last.params2 = {
          file1: maskingImgFile,
          file2: cropImgFile,
          identify: JSON.stringify(this.last.info),
        };
        this.lastSubmit = await Api.lastStepAuthInfo(this.last.params2);
        this.step4data.finishedModal = true; // 신원인증 심사 안내
      } catch (error) {
        if (error.msg) {
          if (this.$isDevServer) {
            this.$vs.notify({
              title: this.$t("notice.title.error"),
              text: "finish<br>" + `${error.code}` + `${error.msg}`,
              position: "top-right",
              color: "danger",
            });
            return;
          } else {
            this.$vs.notify({
              title: this.$t("notice.title.error"),
              text: "finish<br>" + `${error.msg}`,
              position: "top-right",
              color: "danger",
            });
            return;
          }
        } else {
          if (this.$isDevServer) {
            this.$vs.notify({
              title: this.$t("notice.title.error"),
              text: `finish<br>${error.code}<br>입력하신 정보를 다시 확인해 주세요.`,
              position: "top-right",
              color: "danger",
            });
            return;
          } else {
            this.$vs.notify({
              title: this.$t("notice.title.error"),
              text: `finish<br>입력하신 정보를 다시 확인해 주세요.`,
              position: "top-right",
              color: "danger",
            });
            return;
          }
        }
        // if (error.msg) {
        //   if (this.$isDevServer) {
        //     return (this.step4data.wrongAccountMessage = `finish<br>${error.code}<br>${error.msg}`);
        //   } else {
        //     return (this.step4data.wrongAccountMessage = `finish<br>${error.msg}`);
        //   }
        // } else {
        //   if (this.$isDevServer) {
        //     return (this.step4data.wrongAccountMessage = `finish<br>${error.code}<br>입력하신 정보를 다시 확인해 주세요.`);
        //   } else {
        //     return (this.step4data.wrongAccountMessage = `finish<br>입력하신 정보를 다시 확인해 주세요.`);
        //   }
        // }
      }
      // } catch (error) {
      //   this.step4data.wrongAuthNumber = true;
      //   if (error.msg) {
      //     if (this.$isDevServer) {
      //       return (this.step4data.wrongAccountMessage = `${error.code}<br>${error.msg}`);
      //     } else {
      //       return (this.step4data.wrongAccountMessage = `${error.msg}`);
      //     }
      //   } else {
      //     if (this.$isDevServer) {
      //       return (this.step4data.wrongAccountMessage = `${error.code}<br>입력하신 정보를 다시 확인해 주세요.`);
      //     } else {
      //       return (this.step4data.wrongAccountMessage = `입력하신 정보를 다시 확인해 주세요.`);
      //     }
      //   }
      // }
    },
    // 외국인 고객 정보 최종 api 호출
    // async submitforeigner() {
    //   const domesticYn = this.step1data.domesticYn; //국내 거주
    //   // 외국인 json
    //   const params = {
    //     midx: this.userInfo.id, //회원idx
    //     birth:
    //       domesticYn == "Y"
    //         ? this.step1data.foreigner.birthDate
    //         : Moment(this.step3data.foreignerbirth).format("YYYYMMDD"), //생년월일
    //     domesticYn: domesticYn == "Y" ? "Y" : "N", //국내거주여부
    //     nation: this.step1data.nationality, //국적
    //     memberSex:
    //       domesticYn == "Y"
    //         ? this.step1data.foreigner.gender
    //         : this.step3data.genderList, //성별
    //     residenceNation:
    //       domesticYn == "Y"
    //         ? "Republic Of Korea/대한민국"
    //         : this.step2cpndata.nationality, //거주국가or통신사국가
    //     name: "", //이름  //거주는 나이스. 비거주는 null
    //     engName1:
    //       domesticYn == "Y"
    //         ? this.step3data.enSurname
    //         : this.step2cpndata.enSurname, //영문 성
    //     engName2:
    //       domesticYn == "Y"
    //         ? this.step3data.enGivenName
    //         : this.step2cpndata.enGivenName, //영문 이름
    //     inIdNum:
    //       domesticYn == "Y"
    //         ? String(this.step1data.foreigner.birthDate.slice(2)) +
    //           String(this.step3data.inIdNum)
    //         : null, // 외국인 등록번호,
    //     mobNumber:
    //       domesticYn == "Y"
    //         ? this.step1data.foreigner.mobileNo
    //         : this.step2cpndata.mobNumber, //휴대폰번호
    //     addr1: this.step3data.searchData.addr1, //주소1
    //     addr2: this.step3data.searchData.addr2, //주소2
    //     addr3: this.step3data.searchData.addr3, //주소3
    //     tradePur: this.step3data.purposeCode, //거래목적
    //     capiOrigin: this.step3data.sourceOfFundCode, //자금출처
    //     realOwnerYn:
    //       this.step3data.realOwnerModalList == "실제 소유자 맞음" ? "Y" : "N", //실소유자여부
    //     cerCi: domesticYn == "Y" ? this.step1data.foreigner.ci : null, //국내 거주는 나이스, 비거주는 null로 보냄
    //     contractYn: this.step3data.agreeChecked == true ? "Y" : "N", //서약서제출여부
    //     nationCode: this.selectedKycCode, //국적 알파벳 코드
    //     passportNum: domesticYn == "Y" ? "" : this.step3data.passportNumber, //여권 번호
    //     kycCode:
    //       domesticYn == "Y"
    //         ? "KR"
    //         : this.step2cpndata.selectedNationObject.cntCode, //거주 국가 알파벳 코드(통신사 국가)
    //     cddYn: this.step1data.agreeChecked == true ? "Y" : "N", //수집동의여부
    //     idSe: domesticYn == "Y" ? "F" : "P", //거주 F, 비거주 P
    //     joinChannelSe: "MW", //가입채널구분
    //     job: this.step3data.jobCode, // 직업명
    //     jobCategory: this.step3data.jobCategory, //type, danger
    //     jobName: this.step3data.officeName, // 직장명
    //     jobNumber: this.step3data.officeNumber, //직장 연락처
    //     jobAddr1: this.step3data.searchOfficeData.jobAddr1, //직장주소1(우편번호)
    //     jobAddr2: this.step3data.searchOfficeData.jobAddr2, //직장주소2(검색주소)
    //     jobAddr3: this.step3data.searchOfficeData.jobAddr3, //직장주소3(상세주소)
    //     deptName: this.step3data.officePart, //부서명
    //     position: this.step3data.officeLevel, //직위
    //     bizIdNumber: this.step3data.bizIdNumber, //사업자등록번호
    //     induty:
    //       this.step3data.jobCategory == "2" ? this.step3data.jobModalList : "", //업종명 = 직업과 동일
    //     bizNm: this.step3data.indutyName, //업체명
    //     foundDate: this.step3data.foundDate
    //       ? Moment(this.step3data.foundDate).format("YYYY-MM-DD")
    //       : null, //설립일자
    //     bizNumber: this.step3data.bizNumber, //사업장연락처
    //     bizAddr1: this.step3data.searchPersonalData.bizAddr1, //사업장주소(우편번호)
    //     bizAddr2: this.step3data.searchPersonalData.bizAddr2, //사업장주소(검색주소)
    //     bizAddr3: this.step3data.searchPersonalData.bizAddr3, //사업장주소(상세주소)
    //     sbStatus: this.reTry == "Y" ? "RE" : "R", //재인증 여부 체크
    //     frIdRegDate:
    //       domesticYn == "Y"
    //         ? Moment(this.step3data.idCardStartDate).format("YYYY-MM-DD")
    //         : null, //외국인등록증발급일자
    //     frIdExpDate:
    //       domesticYn == "Y"
    //         ? Moment(this.step3data.idCardEndDate).format("YYYY-MM-DD")
    //         : null, //외국인등록증만료일자
    //   };
    //   try {
    //     const res = await Api.foreignerLastStepAuthInfo(params);
    //     this.lastRes = res.data.result;

    //     // 외국인 이미지 파일
    //     // const params2 = {
    //     //   sbStatus: this.reTry == "Y" ? "RE" : "R", //재인증 여부 체크
    //     //   seqidx: this.lastRes, //위 params 던지고 받은 값
    //     //   foreignerIdFrontImg:
    //     //     domesticYn == "Y" ? this.step4krdata.files.idCardFront : null, //국내 거주 외국인. 외국인등록증 앞면
    //     //   foreignerIdBackImg:
    //     //     domesticYn == "Y" ? this.step4krdata.files.idCardFront : null, //국내 거주 외국인. 외국인등록증 뒷면
    //     //   passportImg:
    //     //     domesticYn == "Y" ? null : this.step4othersdata.files.passport, //국내 비거주 외국인. 여권
    //     //   additionalIdImg:
    //     //     domesticYn == "Y"
    //     //       ? null
    //     //       : this.step4othersdata.files.identityDocument, //국내 비거주 외국인. 신분증
    //     //   kycImg: domesticYn == "Y" ? null : this.step4othersdata.files.dues, //국내 비거주 외국인. 거주지 증명
    //     //   ali_token:
    //     //     domesticYn == "Y"
    //     //       ? this.step4krdata.ali_response.ali_token
    //     //       : this.step4othersdata.ali_response.ali_token,
    //     //   ali_sig:
    //     //     domesticYn == "Y"
    //     //       ? this.step4krdata.ali_response.ali_sig
    //     //       : this.step4othersdata.ali_response.ali_sig,
    //     //   ali_csessionid:
    //     //     domesticYn == "Y"
    //     //       ? this.step4krdata.ali_response.ali_csessionid
    //     //       : this.step4othersdata.ali_response.ali_csessionid,
    //     // };

    //     // await Api.lastForeignerImage(params2);
    //     await Api.lastForeignerImage(params2);

    //     this.foreignerAuthIDModal = true;
    //   } catch (error) {
    //     this.$vs.notify({
    //       text: "인증 실패입니다.",
    //       type: "warning",
    //       customClass: "FLYBIT-noti",
    //       position: "top-left",
    //     });
    //   }
    // },
    closeModal() {
      this.mykeepinErrorcloseAuthIDModal = false;
      this.closeAuthIDModal = false;
      this.$router.push({ name: "confirm" });
    },
  },
  destroyed() {
    clearInterval(this.messageConfirmTimer);
  },
};
</script>
<style lang="scss" scoped>
.defaultColor {
  color: #333;
}
.authID-container {
  &.mid {
    min-height: auto;
  }
  .title-wrap {
    position: relative;
    padding: 7px 0;
    border-bottom: 1px solid #eef0f3;
    .title {
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      color: #222222;
    }
    .close-button {
      position: absolute;
      top: 3px;
      right: 12px;
    }
  }
  .content-wrap {
    position: relative;
    padding: 12px 12px 20px;
    font-size: 14px;
    color: #333;
    // 신원인증 안내
    .noti {
      height: 508px;
      font-weight: 300;
      line-height: 1.5;
      color: #222;
    }
    .step {
      .top-wrap {
        .step-title {
          font-size: 14px;
          font-weight: 500;
        }
      }
      .noti-try {
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        color: #333333;
      }
      .round-button-wrap {
        position: relative;
        height: 64px;
        .round-button {
          position: absolute;
          top: 20px;
          left: 50%;
          transform: translateX(-50%);
          width: 208px;
          height: 64px;
          padding: 0 36px;
          border-radius: 162px;
          border: solid 1px #dcdfe3;
          background-color: #ffffff;
          // .text-wrap {
          //   position: absolute;
          //   top: 50%;
          //   left: 50%;
          //   transform: translate(-50%, -50%);
          // }
        }
      }
      .content-wrap {
        .item {
          .title {
            margin-bottom: 8px;
          }
          .button-wrap {
            .detail-noti {
              color: #afafaf;
            }
          }
        }
      }
      .center-content-wrap {
        position: relative;
        height: 176px;
        margin-bottom: 216px;
        .content {
          position: absolute;
          top: 60px;
          left: 50%;
          transform: translateX(-50%);
          .round {
            width: 58px;
            height: 58px;
            margin-left: 44px;
            padding: 16px 16px 16px;
            border: solid 1px rgba(51, 51, 51, 0.1);
            background-color: #fff;
          }
        }
      }
    }
    // step number
    .step-number {
      .number {
        width: 20px;
        height: 20px;
        text-align: center;
        color: #dcdfe3;
        border-radius: 2px;
        background-color: #f7f8fa;
        &.active {
          color: #fff;
          background-color: #333;
        }
      }
    }
    // 하단 버튼
    button.next-button {
      width: 100%;
      padding: 10px 0;
      border-radius: 2px;
      background-color: #00b473;
      &.bottom {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100% - 24px);
      }
      &:disabled {
        border: solid 1px #dadada !important;
        background-color: #dadada !important;
      }
    }
    // 항목 선택 버튼 공통
    button.default {
      width: 100%;
      padding: 10px 0;
      color: #333;
      border-radius: 2px;
      border: solid 1px #dcdfe3;
      background-color: #fff;
      &:disabled {
        color: #afafaf !important;
        border: solid 1px #dcdfe3;
        background-color: #f7f8fa !important;
      }
      &.half {
        width: calc((100% - 12px) / 2);
      }
      &.select-wrap {
        text-align: left !important;
      }
      &.disabled {
        color: #afafaf;
        background-color: #f7f8fa;
      }
      &.abled {
        color: #333;
        background-color: #fff;
      }
      &.selected {
        border: solid 1px #00b473;
        background-color: rgba(0, 180, 115, 0.05);
        // &:before {
        //   content: '';
        //   position: absolute;
        //   top: 12px;
        //   left: 12px;
        //   width: 14px;
        //   height: 14px;
        //   background-image: url("~/src/assets/img/mypage/check_ic_confirm.svg");
        // }
      }
    }
    .button-wrap {
      position: relative;
      &.select-box {
        button.default {
          padding: 10px 9px;
        }
      }
      .detail-noti {
        color: #afafaf;
      }
    }
  }
}
</style>
